import { useSelector } from 'react-redux';

const BASE_STATIC_STORAGE_URL = process.env.REACT_APP_STATIC_STORAGE_URL;

const toolsImages = {
  ConvertVideo: BASE_STATIC_STORAGE_URL + '/images/features/Convert Video.png',
  CompressVideo: BASE_STATIC_STORAGE_URL + '/images/features/Compress Video.png',
  ResizeVideo: BASE_STATIC_STORAGE_URL + '/images/features/Resize Video.png',
  CropVideo: BASE_STATIC_STORAGE_URL + '/images/features/Crop Video.png',
  CutVideo: BASE_STATIC_STORAGE_URL + '/images/features/Cut Video.png',
  LoopVideo: BASE_STATIC_STORAGE_URL + '/images/features/Loop Video.png',
  RotateVideo: BASE_STATIC_STORAGE_URL + '/images/features/Rotate Video.png',
  TranscribeVideo: BASE_STATIC_STORAGE_URL + '/images/features/Transcribe Video.png',
  TranslateVideo: BASE_STATIC_STORAGE_URL + '/images/features/Translate Video.png',
  JoinMergeVideo: BASE_STATIC_STORAGE_URL + '/images/features/Join-Merge Video.png',
  AudioToText: BASE_STATIC_STORAGE_URL + '/images/features/Add Audio to Text.png',
  AutoSubtitles: BASE_STATIC_STORAGE_URL + '/images/features/Auto Subtitles.png'
};

export const useDashboardToolsData = () => {
  const languageStrs = useSelector((store) => store.editdata.languageStrs);

  return [
    { image: toolsImages.ConvertVideo, name: languageStrs.menu_VideoConverter, path: 'feature-convert-video' },
    { image: toolsImages.CompressVideo, name: languageStrs.menu_VideoCompressor, path: 'feature-compress-video' },
    { image: toolsImages.ResizeVideo, name: languageStrs.resize_video, path: 'feature-resize-video' },
    { image: toolsImages.CropVideo, name: languageStrs.menu_Crop, path: 'feature-crop-video' },
    { image: toolsImages.CutVideo, name: languageStrs.menu_Crop, path: 'feature-cut-video' },
    { image: toolsImages.LoopVideo, name: languageStrs.menu_LoopVideo, path: 'feature-loop-video' },
    { image: toolsImages.RotateVideo, name: languageStrs.menu_Rotate, path: 'feature-rotate-video' },
    { image: toolsImages.TranscribeVideo, name: languageStrs.menu_TranscribeVideo, path: 'feature-transcribe-video' },
    { image: toolsImages.TranslateVideo, name: languageStrs.menu_TranslateVideo, path: '' },
    { image: toolsImages.JoinMergeVideo, name: languageStrs.menu_JoinMerge, path: 'feature-joinmerge-video' },
    { image: toolsImages.AudioToText, name: languageStrs.menu_AudioToText, path: '' },
    { image: toolsImages.AutoSubtitles, name: languageStrs.menu_AutoSubtitles, path: '' },
  ];
};
